import { useState, useEffect, useCallback } from "react";
import { getBundleKpiReport } from "../../../service/ReportingService";

const useBundleReport = () => {

  const [data, setData] = useState([]);
  const [error,setError]= useState(null);

  const fetchBundleKpiReport = useCallback(async (page, size, isBundleActive , query) => {
    try {
      const response = await getBundleKpiReport(page, size, isBundleActive, query);
      if (response?.success) {
        setData(response.data.records);
        return response;
      } else {
        setError(response.data);
      }
    } catch (err) {
      setError(err?.message || "Something went wrong.");
    } 
  }, []);

 

  return { data, error, fetchBundleKpiReport };
};

export default useBundleReport;